<div *ngIf="formInit">
  <div *ngIf="leadStyle == 2" style="width: 100%; display: flex; flex-wrap: wrap;"
    [fxLayout]="layout == 1 ? 'column' : 'row wrap'" [formGroup]="form" [fxLayoutGap]="gapBetweenImage">

    <ng-container *ngFor="let field of fields; let i=index">

      <ng-container *ngIf="!field.enableConditionalField || field.visible">


        <ng-container *ngIf="field.inputType !== 'button'; else buttonContainer">
          <div *ngIf="field.label!='LeadStatus' || field.label!='Stage'" [fxFlex]="layout == 2 ? 
               (gapBetweenImage ?  'calc(50% - ' + (gapBetweenImage) + ')' : '50%') 
               : (layout == 3 ? (gapBetweenImage ? 'calc(33.33% - ' + gapBetweenImage + ')' : '33.33%') 
                 : (layout == 4 ? (gapBetweenImage ? 'calc(25% - ' + gapBetweenImage + ')' : '25%') 
                   : '100%'))" style="color: #111; width: 100%;">
            <div style="color: #111; width: 100%;" [type]="type" (valueChange)="onFieldValueChange($event)"
              [formType]="formType" simpleDynamicField [field]="field" [group]="form"></div>
          </div>

        </ng-container>
        <ng-template #buttonContainer>
          <div [fxFlex]="layout == 2 ? 
               (gapBetweenImage ?  'calc(50% - ' + (gapBetweenImage) + ')' : '50%') 
               : (layout == 3 ? (gapBetweenImage ? 'calc(33.33% - ' + gapBetweenImage + ')' : '33.33%') 
                 : (layout == 4 ? (gapBetweenImage ? 'calc(25% - ' + gapBetweenImage + ')' : '25%') 
                   : '100%'))" style="width: 100%; margin-bottom: 16px;">
            <button [attr.guide]="'simple-dynamic-form-btn-1' + '__' + sanitizeUrl(url)" (click)="onSubmit()"
              style="color:#111; width: 100%; height: 45px;" mat-raised-button class="primary">{{field.label}}</button>
          </div>
        </ng-template>
      </ng-container>
    </ng-container>

  </div>
  <div *ngIf="leadStyle == 1" style="width: 100%; display: flex; flex-wrap: wrap;"
    [fxLayout]="layout == 1 ? 'column' : 'row wrap'" [formGroup]="form" [fxLayoutGap]="gapBetweenImage">

    <ng-container *ngFor="let field of fields; let i=index">

      <ng-container *ngIf="!field.enableConditionalField || field.visible">


        <ng-container *ngIf="field.inputType !== 'button'; else buttonContainer">
          <div *ngIf="field.label!='LeadStatus' || field.label!='Stage'" [fxFlex]="layout == 2 ? 
               (gapBetweenImage ?  'calc(50% - ' + (gapBetweenImage) + ')' : '50%') 
               : (layout == 3 ? (gapBetweenImage ? 'calc(33.33% - ' + gapBetweenImage + ')' : '33.33%') 
                 : (layout == 4 ? (gapBetweenImage ? 'calc(25% - ' + gapBetweenImage + ')' : '25%') 
                   : '100%'))" style="width: 100%;">
            <div [type]="type" (valueChange)="onFieldValueChange($event)" [formType]="formType" simpleDynamicField
              [field]="field" [group]="form" style="width: 100%;"></div>
          </div>

        </ng-container>
        <ng-template #buttonContainer>
          <div [fxFlex]="layout == 2 ? 
               (gapBetweenImage ?  'calc(50% - ' + (gapBetweenImage) + ')' : '50%') 
               : (layout == 3 ? (gapBetweenImage ? 'calc(33.33% - ' + gapBetweenImage + ')' : '33.33%') 
                 : (layout == 4 ? (gapBetweenImage ? 'calc(25% - ' + gapBetweenImage + ')' : '25%') 
                   : '100%'))" style="width: 100%; margin-bottom: 16px;">
            <button [attr.guide]="'simple-dynamic-form-btn-2' + '__' + sanitizeUrl(url)" (click)="onSubmit()"
              style="color:white; width: 100%; height: 45px;" mat-raised-button class="primary">{{field.label}}</button>
          </div>
        </ng-template>
      </ng-container>
    </ng-container>

  </div>

</div>

<!-- <pre>
    {{form.value |json}}
  </pre> -->